module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/login-box/login-box.component.css
// module id = ./src/app/login-box/login-box.component.css
// module chunks = main